var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinnedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4126 0.0720593V1.65282L9.62221 1.65282L9.62221 6.39522L11.203 8.76637V10.3471L6.46066 10.3472L6.46063 15.8798L4.87986 15.8799L4.87989 10.3472L0.13752 10.3471L0.137531 8.76636L1.71831 6.39519L1.71831 1.65286H0.927929L0.927918 0.0720816L10.4126 0.0720593Z",
    fill: "#0F62FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnedIcon);
export default __webpack_public_path__ + "static/media/pinned-icon.dbd6b606712dbe73384180081b9ba827.svg";
export { ForwardRef as ReactComponent };